import Pin from '@/infra/map/pins/Pin';
import SpotType from '@/model/spot/PinType';
import store from '@/store';

/**
 * 現在地を表すスポット用ピンを扱うクラス
 * spotモデルを渡すと、
 * 言語・スポットコードからピンの画像を選びます。
 * (現在Map画面で使用しています)
 */
export default class UserCurrentLocationPin extends Pin {
  constructor(map, spot) {
    if (!map || !spot) {
      return;
    }

    // スポットの役割
    const SPOT_TYPE = SpotType.USER_LOCATION;

    // vuexから言語を取得
    const lang = store.state.lang.value;
    super(map,
      new navitime.geo.Icon(
        require(`@/assets/images/map/userlocationPin.svg`),
        {
          size: {                   // 画像サイズ
            width: SPOT_TYPE.size.width,             // 画像の幅
            height: SPOT_TYPE.size.height           // 画像の高さ
          }
        }
      ),
      {
        lat: spot.coord.lat,
        lon: spot.coord.lon,
      },
      {
        type: SPOT_TYPE.name || null,
        z_index: SPOT_TYPE.zIndex || 1,
        events: null,
        spot: spot || null,
      });
  }
}
